import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.707 1.293a1 1 0 0 0-1.414 0l-6 6a1 1 0 0 0 1.414 1.414L2 8.414V13a1 1 0 0 0 1 1h3v-3a1 1 0 1 1 2 0v3h3a1 1 0 0 0 1-1V8.414l.293.293a1 1 0 1 0 1.414-1.414z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceHomeHouse = { render };
export {
  interfaceHomeHouse as default,
  render
};
//# sourceMappingURL=interface-home-house.svg.js.map
